/**
 * Enum for address types.
 * @readonly
 * @enum {String} AddressTypeEnum
 */

const AddressTypeEnum = {
  DEFAULT        : 'default',
  INTERNAL_OFFICE: 'internal_office'
}

export default AddressTypeEnum
